export default __webpack_public_path__ + "static/media/baners.beba03b6.png";